import _setInterval from 'setinterval-plus'
export default class ExpertiseHome {

    constructor(el) {
        this.el = el;
        this.items = this.getItems();
        this.setEvents();
        this.show(this.items[0]);
        this.timer = new _setInterval(this.tick.bind(this), 4000) // Timer starts ticking
    }

    static get selector() {
        return '.expertiseHome';
    }    

    // Events
    e_click(e, item) {
        if(e.target.classList.contains('expertiseHome__itemLink')){

        }else{
            e.preventDefault();
            this.show(item);
            this.timer.stop();
        }
    }

    e_enter(e, item) {
        if (!item.isActive) return;
        this.timer.pause();

    }

    e_leave(e, item) {
        if (!item.isActive) return;
        this.timer.resume();
    }


    // Functions
    getItems (el){
        let items = [];
        let elements = this.el.querySelectorAll('.expertiseHome__item');
        elements.forEach((element,index) => {
            let item = {};
            item.index = index;
            item.el = element;
            item.accordion = item.el.querySelector('.expertiseHome__itemAccordion');
            item.content = item.el.querySelector('.expertiseHome__itemAccordionContent');
            item.isActive = false;

            items.push(item);
        });
        return items;
    }

    setEvents (){
        this.items.forEach( item => {
            item.el.addEventListener('click', (e) => this.e_click(e, item));
            item.el.addEventListener('mouseenter', (e) => this.e_enter(e, item));
            item.el.addEventListener('mouseleave', (e) => this.e_leave(e, item));

        });
    }

    tick() {
        let nextIndex = (this.activeItem.index + 1) % this.items.length;
        let nextItem = this.items[nextIndex];
        this.show(nextItem);
    }



    show(item) {
        if (!item) return;
        if (item.isActive) return;
        this.hideAll();
        item.el.classList.add('expertiseHome__item--active');
        item.isActive = true;
        
        item.accordion.style.maxHeight = item.content.offsetHeight + "px";

        this.activeItem = item;
    }


    hide(item){
        if (!item) return;
        if (!item.isActive) return;
        item.isActive = false;
        item.accordion.style.maxHeight = "";
        item.el.classList.remove('expertiseHome__item--active');   
    }

    hideAll(){
        this.items.forEach( item => {
           this.hide(item);
        });
    }
}